/* @flow */
// typecheck: ignore file
import React from 'react';
import { clone } from 'lodash';

import type { EntityType } from 'lib/TextEntities';

import styles from './styles/TextWithEntities.css';

/**
 * Adds rich-text entities to text using a serialize format.
 *
 * See `TextEntities` for various parsers.
 */

class TextWithEntities extends React.PureComponent {
  props: {
    /** Text to render with entities */
    text: string,
    /** Array of entities (can be nested) to render in the text */
    entities: EntityType[],
    /** Don't render nested entities (e.g., Emoji inside of an email address) */
    shallow?: bool,
  };

  _renderEntities = (text: string, entities: EntityType[], offset: number, originalText: string) => {
    const output = [];

    while (entities[0] && entities[0].offset - offset < text.length) {
      const entity = entities.shift();

      const index = entity.offset - offset;
      if (index > 0) {
        output.push(text.substr(0, index));
      }

      if (this.props.shallow && entity.offset < offset) {
        continue;
      }

      const rendered = this.props.shallow ?
        originalText.substr(entity.offset, entity.length) :
        this._renderEntities(
          text.substr(index, entity.length),
          entities,
          entity.offset,
          originalText
        );

      let element = entity.renderer(
        originalText.substr(entity.offset, entity.length),
        rendered,
        entity.data
      );

      if (React.isValidElement(element)) {
        element = React.cloneElement(element, { key: entity.offset });
      }

      output.push(element);

      text = text.substr(index + entity.length); // eslint-disable-line no-param-reassign
      offset = entity.offset + entity.length; // eslint-disable-line no-param-reassign
    }

    if (!output.length) {
      return text;
    }

    output.push(text);

    return output;
  };

  renderEntities = (text: string, entities: EntityType[]) => {
    const clonedEntities = clone(entities);
    clonedEntities.sort((a, b) => a.offset - b.offset || b.length - a.length);
    return this._renderEntities(text, clonedEntities, 0, text);
  };

  render() {
    return (
      <span className={styles.this}>
        {this.renderEntities(this.props.text, this.props.entities)}
      </span>
    );
  }
}

export default TextWithEntities;



// WEBPACK FOOTER //
// ./src/components/TextWithEntities.jsx